export const parseTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
};
